import React from 'react'
import { verificationContent } from 'utils/constant/siteIntro/landingPage';

import identification from "assets/siteIntro/landingPage/icons/identification.svg"
import { LazyImage } from 'components/image';
const verificationImage = `${process.env.REACT_APP_CLOUDINARY_IMAGE_BASEURL_V1}CoupleSquad Static Assets/siteIntro/landing/utwqvf5oeaxbketazrua`


function ImageCycle() {


    return (
        <div className="bg-[#f6f6f6] flex items-center">
            <div className="w-full mt-24">
                <div className="flex flex-col items-center text-black">
                    <div className='text-3xl sm:text-4xl md:text-[40px]  mx-4 md:mx-0 text-center'>Restricted Area for Fake IDs</div>
                    <div className="w-[90%] lg:w-[70%] flex flex-wrap items-center justify-around mt-10">
                        {verificationContent?.map((item) => (

                            <div className='mt-5 lg:mt-0'>
                                <div className="flex items-center">
                                    <LazyImage src={item.img} />
                                    <div className='text-xl font-semibold'>{item.title}</div>
                                </div>
                                <p className='ms-10 text-base w-[95%] md:w-[21rem] text-subText'>{item.description}</p>
                            </div>
                        ))}
                    </div>
                    <div className="flex items-center justify-center h-[75vh] w-[95%] md:w-[70%]">
                        <div className="flex items-center justify-center w-full h-full overflow-hidden">
                            <LazyImage src={verificationImage} />
                        </div>
                    </div>
                    <div className="flex flex-col md:flex-row justify-between items-center text-center w-full px-4 md:w-[70%] md:px-0 mb-10">
                        <div className='text-xl md:text-2xl lg:text-[40px]  w-full md:w-auto'>
                            We care about real profiles, not just numbers.Quality matters more than quantity.
                        </div>
                        <LazyImage src={identification} className='w-[50px] md:w-[80px]' />
                    </div>

                </div>
            </div>
        </div>

    );
}

export default React.memo(ImageCycle);

